import React from 'react';

import styles from './OffRampBox.module.scss';

const OffRampBox = ({title, description, btnTxt, btnAction, newTab, actionLinkText, actionLink}) => {
  return (
    <div className={styles["container"]}>
      <div className={styles["title"]}>
        {title}
      </div>
      <div className={styles["description"]}>
        {description}
      </div>
      <div className={styles["button-boxes"]}>
        {newTab && (
          <a className={styles["buttonBorder"]} href={btnAction} target="_blank"  rel="noopener noreferrer">{btnTxt}</a>
        )}
        {!newTab && (
          <a className={styles["buttonBorder"]} href={btnAction}>{btnTxt}</a>
        )}
        { actionLinkText &&
          <button className={styles["action-link"]} onClick={actionLink}>{actionLinkText}</button>
        }
      </div>
    </div>
  );
};

export default OffRampBox;
